import type {
  SettingsPageContextProps,
  SettingsPageContextServices,
} from '../../../types';
import { addLocationChangeHandler } from './location';
import { addLoginHandler } from './login';
import { handleNavigation } from './navigation';
import { addInitialDataForWidgetPlugins } from './widget-plugins';

export const oldAddHandlers = (
  contextProps: SettingsPageContextProps,
  contextServices: SettingsPageContextServices,
) => {
  addInitialDataForWidgetPlugins(contextProps, contextServices);
  addLocationChangeHandler(contextProps, contextServices);
  addLoginHandler(contextProps, contextServices);
  return handleNavigation(contextProps, contextServices);
};

export const addHandlers = (
  contextProps: SettingsPageContextProps,
  contextServices: SettingsPageContextServices,
) => {
  addLocationChangeHandler(contextProps, contextServices);
  addLoginHandler(contextProps, contextServices);
};

export { addInitialDataForWidgetPlugins, handleNavigation };
